export const BILL_TYPES = {
  UNSETTLED: 'unsettled',
  CLEARED: 'cleared',
  VOID: 'void',
};
